import { render } from "./App.vue?vue&type=template&id=625113f2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=625113f2&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__